/* ==========================================================================
   MX theme – mx-global.js
   Shared, dependency-free helpers for every template. Public API: window.MXTheme
     MXTheme.config                     store settings (snippets/mx-theme-config.liquid)
     MXTheme.money(cents)               format with the store's money format
     MXTheme.cart.add(data, opts)       FormData or { items: [...] } → the MX Header drawer if present, else the Cart API
     MXTheme.toast(message, link)       a short confirmation in the page's live region
     MXTheme.wishlist                   .list() .has(handle) .toggle(handle) .remove(handle)   (this browser only)
     MXTheme.recent                     .list() .add(handle)                                   (this browser only)
     MXTheme.search.parse(text)         { terms, min, max, sort, original } from "RTX 5070 under 3 lakh"
     MXTheme.search.url(text, extra)    the storefront URL for that search, with a real price filter
     MXTheme.whatsapp(message)          a wa.me link, or '' without a number
   Behaviour wired here for any markup in the theme:
     [data-mx-reveal]                   fades in on scroll (not with reduced motion)
     form[data-mx-nl-search]            budget-aware search submit
     [data-mx-wish="handle"]            wishlist toggle buttons; [data-mx-wish-count] badges
   Events on document: mx:wishlist:change { list }, mx:cart:added { via }
   ========================================================================== */
(function () {
  'use strict';
  if (window.MXTheme && window.MXTheme.ready) return;

  var MX = (window.MXTheme = window.MXTheme || {});
  MX.ready = true;
  var cfgEl = document.getElementById('mx-theme-config');
  var cfg = {};
  try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { cfg = {}; }
  MX.config = cfg;
  var strings = cfg.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function store(key, fallback) {
    try { var v = JSON.parse(window.localStorage.getItem(key)); return Array.isArray(v) ? v : fallback; } catch (e) { return fallback; }
  }
  function save(key, value) { try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode: keep in memory */ } }

  /* ------------------------------------------------------------ money */
  MX.money = function (cents, format) {
    format = format || cfg.moneyFormat || '{{amount}}';
    var n = Number(cents) / 100;
    if (isNaN(n)) n = 0;
    function fmt(num, decimals, thousands, decimal) {
      var fixed = num.toFixed(decimals).split('.');
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? whole + decimal + fixed[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(n, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(n, 2, ' ', ',');
        default: return fmt(n, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  };

  /* ------------------------------------------------------------ toast */
  var toastTimer;
  MX.toast = function (message, link) {
    var el = document.querySelector('[data-mx-toast]');
    if (!el || !message) return;
    el.textContent = '';
    var text = document.createElement('span');
    text.textContent = message;
    el.appendChild(text);
    if (link && link.href) {
      var a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label || '';
      el.appendChild(a);
    }
    void el.offsetWidth;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3600);
  };

  /* ------------------------------------------------------------ cart */
  MX.cart = {
    /* Resolves once the cart has accepted the item. Uses, in order: a theme hook, the MX Header drawer, the Cart API. */
    add: function (data, opts) {
      opts = opts || {};
      var hook = window.MXProduct && window.MXProduct.cart;
      if (hook && typeof hook.add === 'function') return Promise.resolve(hook.add(data, opts)).then(function () { return done('custom'); });
      var header = window.MXHeader && window.MXHeader.cart;
      if (header && typeof header.add === 'function' && cfg.cartType !== 'page') {
        return header.add(data, { open: opts.open, trigger: opts.trigger }).then(function () { return done('mx-header'); }, function (err) {
          throw new Error((err && (err.description || err.message)) || strings.addError || '');
        });
      }
      var body = data instanceof FormData ? data : JSON.stringify(data);
      var headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      if (!(data instanceof FormData)) headers['Content-Type'] = 'application/json';
      var addUrl = ((cfg.routes && cfg.routes.cartAdd) || '/cart/add').replace(/\/$/, '') + '.js';
      return fetch(addUrl, { method: 'POST', credentials: 'same-origin', headers: headers, body: body })
        .catch(function () { throw new Error(strings.addError || ''); })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (d) {
            if (!res.ok || (d && d.status && d.status >= 400)) throw new Error((res.status < 500 && d && (d.description || d.message)) || strings.addError || '');
            document.dispatchEvent(new CustomEvent('mx:cart:refresh', { detail: { source: 'mx-theme' } }));
            if (opts.toast !== false) MX.toast(strings.added || 'Added to cart', { href: (cfg.routes && cfg.routes.cart) || '/cart', label: strings.viewCart || 'View cart' });
            return done('fetch');
          });
        });
      function done(via) { document.dispatchEvent(new CustomEvent('mx:cart:added', { detail: { via: via } })); return via; }
    },
    /* Adds, then goes to checkout (Buy now). */
    buyNow: function (data) {
      return MX.cart.add(data, { open: false, toast: false }).then(function () { window.location.assign('/checkout'); });
    }
  };

  /* ------------------------------------------------------------ wishlist (this browser) */
  var WISH = 'mx:wishlist';
  MX.wishlist = {
    enabled: !cfg.wishlist || cfg.wishlist.enabled !== false,
    list: function () { return store(WISH, []); },
    has: function (handle) { return MX.wishlist.list().indexOf(handle) > -1; },
    toggle: function (handle) {
      var list = MX.wishlist.list();
      var i = list.indexOf(handle);
      var added = i === -1;
      if (added) list.unshift(handle); else list.splice(i, 1);
      save(WISH, list.slice(0, 100));
      syncWish();
      document.dispatchEvent(new CustomEvent('mx:wishlist:change', { detail: { list: MX.wishlist.list(), handle: handle, added: added } }));
      var url = cfg.wishlist && cfg.wishlist.url;
      MX.toast(added ? (strings.wishAdded || 'Saved to your wishlist') : (strings.wishRemoved || 'Removed from your wishlist'), added && url ? { href: url, label: 'View' } : null);
      return added;
    },
    remove: function (handle) { if (MX.wishlist.has(handle)) MX.wishlist.toggle(handle); }
  };
  function syncWish(root) {
    var list = MX.wishlist.list();
    (root || document).querySelectorAll('[data-mx-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-mx-wish')) > -1 ? 'true' : 'false');
    });
    document.querySelectorAll('[data-mx-wish-count]').forEach(function (el) {
      el.textContent = list.length ? String(list.length) : '';
      el.hidden = !list.length;
    });
  }
  MX.syncWishlist = syncWish;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mx-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    MX.wishlist.toggle(b.getAttribute('data-mx-wish'));
    if (!reduceMotion.matches) { b.classList.remove('is-popping'); void b.offsetWidth; b.classList.add('is-popping'); }
  });
  window.addEventListener('storage', function (e) { if (e.key === WISH) syncWish(); });

  /* ------------------------------------------------------------ recently viewed (this browser) */
  var RECENT = 'mx:recent';
  MX.recent = {
    list: function () { return store(RECENT, []); },
    add: function (handle) {
      if (!handle) return;
      var list = MX.recent.list().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      save(RECENT, list.slice(0, 16));
    }
  };

  /* ------------------------------------------------------------ WhatsApp */
  MX.whatsapp = function (message) {
    var n = cfg.whatsapp && cfg.whatsapp.number;
    if (!n) return '';
    return 'https://wa.me/' + String(n).replace(/[^\d]/g, '') + (message ? '?text=' + encodeURIComponent(message) : '');
  };

  /* ------------------------------------------------------------ natural-language search
     "RTX 5070 under 3 lakh" → { terms: 'RTX 5070', max: 300000 }. A number only counts as a price when it has an
     amount word (3 lakh, 60k), a currency word (Rs 50,000), or sits beside a budget word (under 50000, 50000 tak).
     Sizes and model numbers (27 inch, 180Hz, 32GB, RTX 5070) are left in the search text. */
  var sc = cfg.search || {};
  function words(s) { return String(s || '').toLowerCase().split(/[,\n]/).map(function (w) { return w.trim(); }).filter(Boolean); }
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function alt(list) { return list.slice().sort(function (a, b) { return b.length - a.length; }).map(esc).join('|'); }
  var UNITS = {};
  String(sc.units || 'lakh, lac, lacs, lakhs = 100000\nk, hazar, hazaar, thousand = 1000\ncrore, cr = 10000000').split('\n').forEach(function (line) {
    var parts = line.split('=');
    var mult = parseFloat(parts[1]);
    if (!(mult > 0)) return;
    words(parts[0]).forEach(function (w) { UNITS[w] = mult; });
  });
  var unitRe = alt(Object.keys(UNITS));
  var maxRe = alt(words(sc.maxWords || 'under, below, upto, up to, within, max, less than, tak, se kam, ke andar, budget'));
  var minRe = alt(words(sc.minWords || 'above, over, more than, min, at least, se zyada, se upar'));
  var curRe = alt(words(sc.currencyWords || 'rs, rs., pkr, rupees, rupay'));
  var cheap = words(sc.cheapWords || 'sasta, saste, sasti, cheap, cheapest, budget, affordable');
  var premium = words(sc.premiumWords || 'mehnga, premium, high end, flagship, expensive');
  var AMOUNT = '(?:(' + curRe + ')\\s*)?(\\d+(?:[.,]\\d+)*)\\s*(' + (unitRe || 'x^') + ')?(?![\\w])';

  function amountOf(m) {
    var raw = m[2];
    var unit = m[3] ? UNITS[m[3].toLowerCase()] : 0;
    /* 3,00,000 and 300,000 are thousands separators; 1.5 lakh is a decimal */
    var n = unit ? parseFloat(raw.replace(/,/g, '')) : parseFloat(raw.replace(/[,.](?=\d{2,3}(\D|$))/g, ''));
    if (isNaN(n)) return null;
    return { value: unit ? n * unit : n, hasUnit: !!unit, hasCurrency: !!m[1], index: m.index, length: m[0].length };
  }

  function parse(text) {
    var original = String(text || '').trim();
    var out = { original: original, terms: original, min: null, max: null, sort: null };
    if (!original || sc.enabled === false) return out;
    var s = ' ' + original + ' ';
    var low = s.toLowerCase();
    var cut = []; /* [start, end) ranges of the text that were understood */

    /* ranges first: 50k-80k, 50k to 80k, 50k se 80k, between 50k and 80k */
    var rangeRe = new RegExp('(?:between\\s+)?' + AMOUNT + '\\s*(?:-|–|to|and|se)\\s*' + AMOUNT, 'ig');
    var m;
    while ((m = rangeRe.exec(low))) {
      var a = amountOf([m[0], m[1], m[2], m[3]]);
      var b = amountOf([m[0], m[4], m[5], m[6]]);
      if (!a || !b) continue;
      if (!(a.hasUnit || a.hasCurrency || b.hasUnit || b.hasCurrency)) continue;
      /* "50-80k": the unit of the second number applies to both */
      if (!a.hasUnit && b.hasUnit && m[6]) a.value = a.value * UNITS[m[6].toLowerCase()];
      out.min = Math.min(a.value, b.value);
      out.max = Math.max(a.value, b.value);
      cut.push([m.index, m.index + m[0].length]);
      break;
    }

    if (out.max === null && out.min === null) {
      /* every candidate, then the best: an amount word or currency beats a bare number beside a budget word */
      var single = new RegExp(AMOUNT, 'ig');
      var best = null;
      while ((m = single.exec(low))) {
        var amt = amountOf(m);
        if (!amt) continue;
        var start = m.index, end = m.index + m[0].length;
        var before = low.slice(0, start), after = low.slice(end);
        var bMax = new RegExp('(?:^|\\s)(' + maxRe + ')\\s*$').exec(before);
        var bMin = new RegExp('(?:^|\\s)(' + minRe + ')\\s*$').exec(before);
        var aMax = new RegExp('^\\s*(' + maxRe + ')(?=\\s|$)').exec(after);
        var aMin = new RegExp('^\\s*(' + minRe + ')(?=\\s|$)').exec(after);
        var near = bMax || bMin || aMax || aMin;
        var score = (amt.hasUnit || amt.hasCurrency ? 2 : 0) + (near ? 1 : 0);
        if (!(amt.hasUnit || amt.hasCurrency) && !(near && amt.value >= 500)) continue;
        if (best && best.score >= score) continue;
        var lead = function (x) { return x ? x[0].length - x[0].replace(/^\s+/, '').length : 0; };
        best = {
          score: score, amt: amt, isMin: !!(bMin || aMin),
          from: bMax ? start - bMax[0].length + lead(bMax) : bMin ? start - bMin[0].length + lead(bMin) : start,
          to: aMax ? end + aMax[0].length : aMin ? end + aMin[0].length : end
        };
      }
      if (best) {
        if (best.isMin) out.min = best.amt.value; else out.max = best.amt.value;
        cut.push([best.from, best.to]);
      }
    }

    /* cheapest / most expensive first */
    function grab(list, value) {
      list.forEach(function (w) {
        var re = new RegExp('(^|\\s)' + esc(w) + '(?=\\s|$)', 'i');
        var hit = re.exec(low);
        var taken = hit && cut.some(function (r) { return hit.index + hit[1].length >= r[0] && hit.index + hit[1].length < r[1]; });
        if (hit && !taken && !out.sort) { out.sort = value; cut.push([hit.index + hit[1].length, hit.index + hit[0].length]); }
      });
    }
    grab(cheap, 'price-ascending');
    grab(premium, 'price-descending');

    var terms = '';
    for (var i = 0; i < s.length; i++) {
      var inside = cut.some(function (r) { return i >= r[0] && i < r[1]; });
      terms += inside ? ' ' : s[i];
    }
    out.terms = terms.replace(/\s+/g, ' ').trim();
    if (out.min !== null) out.min = Math.round(out.min);
    if (out.max !== null) out.max = Math.round(out.max);
    return out;
  }

  function searchUrl(text, extra) {
    var q = parse(text);
    var routes = cfg.routes || {};
    var params = new URLSearchParams();
    var base;
    if (q.terms) {
      base = routes.search || '/search';
      params.set('q', q.terms);
      params.set('options[prefix]', 'last');
      params.set('type', 'product');
    } else {
      /* only a budget: browse everything within it */
      base = routes.allProducts || '/collections/all';
    }
    if (q.min !== null) params.set('filter.v.price.gte', String(q.min));
    if (q.max !== null) params.set('filter.v.price.lte', String(q.max));
    if (q.sort) params.set('sort_by', q.sort);
    if (q.original && q.original !== q.terms) params.set('mx_ask', q.original);
    if (extra) Object.keys(extra).forEach(function (k) { params.set(k, extra[k]); });
    return base + '?' + params.toString();
  }
  MX.search = { parse: parse, url: searchUrl };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-mx-nl-search]');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    var value = input ? input.value.trim() : '';
    if (!value) { e.preventDefault(); if (input) input.focus(); return; }
    var q = parse(value);
    if (q.min === null && q.max === null && !q.sort) return; /* nothing to translate: Shopify's own search */
    e.preventDefault();
    window.location.assign(searchUrl(value));
  });

  /* ------------------------------------------------------------ scroll reveal */
  function initReveal() {
    var items = document.querySelectorAll('[data-mx-reveal]:not(.is-revealed)');
    if (!items.length) return;
    if (cfg.reveal === false || reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-revealed'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
    /* failsafe: never leave content hidden */
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-revealed'); }); }, 4000);
  }
  MX.reveal = initReveal;

  /* ------------------------------------------------------------ <mx-section-loader data-url>
     Swaps itself for a section fetched from data-url (Section Rendering API), when it comes near the screen:
     used for product recommendations, which Shopify fills only on their own URL. Nothing is shown on failure. */
  if (!customElements.get('mx-section-loader')) {
    customElements.define('mx-section-loader', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        if (!('IntersectionObserver' in window)) return this.load();
        this.io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { self.io.disconnect(); self.load(); } }, { rootMargin: '600px 0px' });
        this.io.observe(this);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
      load() {
        var self = this;
        var url = this.getAttribute('data-url');
        if (!url || this.loading) return;
        this.loading = true;
        fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          var doc = new DOMParser().parseFromString(html || '', 'text/html');
          var wrap = doc.querySelector('.shopify-section') || doc.body;
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(wrap.childNodes).forEach(function (n) {
            if (n.nodeName === 'SCRIPT' || n.nodeName === 'MX-SECTION-LOADER') return;
            frag.appendChild(document.importNode(n, true));
          });
          var parent = self.parentNode;
          if (!parent) return;
          parent.replaceChild(frag, self);
          initReveal();
          syncWish(parent);
          document.dispatchEvent(new CustomEvent('mx:section:loaded', { detail: { target: parent } }));
        }).catch(function () { self.remove(); });
      }
    });
  }

  /* ------------------------------------------------------------ --mx-header-h on <html>
     How much of the top of the screen a sticky or fixed header covers right now, so sticky bars and scroll targets
     (product details tabs, filters) sit below it. */
  var headerTick = false;
  /* Only the header group counts (never a sticky bar of the page itself, which would feed back into its own top),
     and only the part that is visible: a collapsing header keeps its hidden menu row in the layout. */
  function visibleBottom(el, depth) {
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) return 0;
    var r = el.getBoundingClientRect();
    if (r.height < 1 || r.width < 1) return 0;
    var paints = cs.backgroundColor !== 'rgba(0, 0, 0, 0)' || cs.backgroundImage !== 'none' || parseFloat(cs.borderBottomWidth) > 0 || cs.boxShadow !== 'none';
    if (paints || depth >= 3 || !el.children.length) return r.bottom;
    var b = 0;
    for (var i = 0; i < el.children.length; i++) b = Math.max(b, visibleBottom(el.children[i], depth + 1));
    return b;
  }
  var lastHeaderH = -1;
  function measureHeader() {
    headerTick = false;
    var h = 0;
    var parts = document.querySelectorAll('.shopify-section-group-header-group, body > header, [data-mx-header]');
    for (var i = 0; i < parts.length; i++) {
      for (var el = parts[i]; el && el !== document.body; el = el.parentElement) {
        var pos = getComputedStyle(el).position;
        if (pos !== 'fixed' && pos !== 'sticky') continue;
        var r = el.getBoundingClientRect();
        if (r.top <= 4 && r.bottom > 0 && r.top < window.innerHeight / 2) {
          var b = 0;
          for (var c = 0; c < parts[i].children.length; c++) b = Math.max(b, visibleBottom(parts[i].children[c], 0));
          h = Math.max(h, Math.min(Math.round(b || r.bottom), Math.round(window.innerHeight / 2)));
        }
        break;
      }
    }
    if (h !== lastHeaderH) { lastHeaderH = h; document.documentElement.style.setProperty('--mx-header-h', h + 'px'); }
  }
  function queueHeader() { if (!headerTick) { headerTick = true; requestAnimationFrame(measureHeader); } }
  window.addEventListener('scroll', queueHeader, { passive: true });
  window.addEventListener('resize', queueHeader);
  /* the collapsing header animates; measure again when that finishes */
  document.addEventListener('transitionend', function (e) { if (e.target.closest && e.target.closest('.shopify-section-group-header-group')) queueHeader(); });

  function ready() {
    initReveal();
    syncWish();
    measureHeader();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', function (e) { initReveal(); syncWish(e.target); });
})();
